import { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import router from './router'
import './globals.css'
import 'react-toastify/dist/ReactToastify.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import initClarity from './initClarity'

function App() {
  const queryClient = new QueryClient()
  useEffect(() => {
    if (import.meta.env.PROD) {
      initClarity()
    }
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <ToastContainer rtl theme="colored" position="top-center" />
      <RouterProvider router={router} />
    </QueryClientProvider>
  )
}

export default App
